export const SELECTIONS_OVERLAY_CONTAINER_ID = 'selections-overlay-container';

export function isElementVisiblyRendered(element: HTMLElement): boolean {
  if (element.style.display === 'none') {
    return false;
  }

  const rect = element.getBoundingClientRect();

  return rect.width > 0 && rect.height > 0;
}

export function rectsIntersectWithPositiveArea(
  a: DOMRectReadOnly,
  b: DOMRectReadOnly
): boolean {
  const left = Math.max(a.left, b.left);
  const right = Math.min(a.right, b.right);
  const top = Math.max(a.top, b.top);
  const bottom = Math.min(a.bottom, b.bottom);

  return left < right && top < bottom;
}
